import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { VendorDialogComponent } from './vendor-dialog.component'
import { VendorResponse } from '@tokeet-frontend/vendors'

@Injectable()
export class VendorDialogService {
  constructor(private dialog: DialogService) {}

  open(vendor?: VendorResponse) {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      data: {
        vendor,
      },
    }

    return this.dialog.openVariableDialog(VendorDialogComponent, defaultConfig)
  }
}
